import { Box, Container, createTheme, CssBaseline, Grid, Paper, Slide, TextField, ThemeProvider, Typography } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { renderToString } from 'react-dom/server';
import { generateRef } from "../../helpers/generateRef";
import ApplicationBar from "../modules/ui/ApplicationBar";
import { ButtonSubmit } from "../modules/ui/ButtonSubmit";
import { Footer } from "../modules/ui/Footer";
import { GroupUserData } from "../modules/ui/GroupUserData";
import { SelectCustomWithOther } from "../modules/ui/SelectCustomWithOther";
import { TextareaCustom } from "../modules/ui/TextareaCustom";
import QRCode from 'qrcode';
import Swal from "sweetalert2";
import validator from 'validator';
import { SendingDialog } from "../modules/dialogs/SendingDialog";
import { sendEmail } from "../../services/sendEmail";
import { getOneInByClave, postIn } from "../../services/crudCustom";
import { uploadFile } from "../../services/uploadFile";
import { setEmailBodyConfirm } from "../../helpers/setEmailBodyConfirm";
import { WaitDialog } from "../modules/dialogs/WaitDialog";


export const Bioeconomics = () => {

    // state para cargar info del evento
    const [isLoading, setIsLoading] = useState(false);

    // state para los valores del evento
    const [event, setEvent] = useState({ 
        id: "",
        claveProyecto: "",
        tituloEvento: "",
        urlLogo: "",
        tabla: "",
        solicitudFolio: "",
        correoEvento: "",
    });

    // state para los valores del formulario
    const [formValues, setFormValues] = useState({
        partApellidoPaterno: "",
        partApellidoMaterno: "",
        partNombres: "",
        partCorreo: "",
        partCorreoConfirma: "",
        partGenero: "",
        partInstitucion: "",
        partOcupacion: "",

        tipoRegistro: "Oyente",
        comentarios: "",

        extranjero: false,
        factPais: "",
        requiereFactura: false,
        factNombre: "",
        factRfc: "",
        factCP: "",
        factUsoCFDI: "",
        factRegimenFiscal: "",
        refBancaria: "",
        claveProyRec: "",
        fechaRegistro: "",
        compPago: "",
        fechaPago: "",
    });
    const {
        partApellidoPaterno,
        partApellidoMaterno,
        partNombres,
        partCorreo,
        partCorreoConfirma,
        partGenero,
        partInstitucion,
        partOcupacion,

        tipoRegistro,
        comentarios,

        extranjero,
        factPais,
        requiereFactura,
        factNombre,
        factRfc,
        factCP,
        factUsoCFDI,
        factRegimenFiscal,
        refBancaria,
        claveProyRec,
        fechaRegistro,
        compPago,
        fechaPago,
    } = formValues;

    // state para controlar si es estudiante
    const [isStudent, setIsStudent] = useState(false);

    // state para controlar si participa como oyente
    const [esOyente] = useState(true);

    // state para el codigo QR
    const [src, setSrc] = useState({ qrdata:"" });

    // Para mostrar un dialogo mientras se envia la info (waiting dialog)
    const [sendingForm, setSendingForm] = useState(false);

    // states para los fileuploads
    const [fileCredencial, setFileCredencial] = useState({ file: '', });
    const [fileResumen, setFileResumen] = useState({ file: '', });
    const [fileExtenso, setFileExtenso] = useState({ file: '', });
    
    const setFileState = (e) => {    
        
        switch (e.target.name) {
            case 'fileCredencial':
                setFileCredencial({ file: e.target.files[0] });    
                break;
            case 'fileResumen':
                setFileResumen({ file: e.target.files[0] });    
                break;
            case 'fileExtenso':
                setFileExtenso({ file: e.target.files[0] });    
                break;
            default:
                break;
        }
    };
    

    // Al modificar un dato en un input
    const handleInputChange = ({ target }) => {
        const { name, value } = target;

        // console.log(name, value);

        setFormValues({
            ...formValues,
            [name]: value,
        });
    }
        
    // Al modificar un dato en 'Ocupacion'
    const handleOcupacionChange = ({ target }) => {
        console.log(target.name, target.value);

        const { name, value } = target;
        // Si incluye la palabra 'Estudiante' se establece el state -isStudent-
        value.includes("Estudiante") ? setIsStudent(true) : setIsStudent(false) ;

        setFormValues({
            ...formValues,
            [name]: value,
        });
    }
    
    // Validar el formumario
    const isFormValid = () => {

        // Campos obligatorios
        if ( [ partApellidoPaterno, partNombres, partCorreo, partGenero.trim(), partInstitucion, partOcupacion.trim(), tipoRegistro ].includes("") ) {
            Swal.fire("Datos incompletos", "Los campos marcados con [ * ] son obligatorios.", "error");
            return false;
        }

        // Correo valido
        if ( !validator.isEmail(partCorreo) ) {
            Swal.fire("Correo electrónico incorrecto", "Confirmar el correo electrónico ingresado.", "error");
            return false;
        }

        // Campos de correo diferentes
        if ( !validator.equals(partCorreo, partCorreoConfirma) ) {
            Swal.fire("Confirmar correo electrónico", "Los campos de comparación no coinciden.", "error");
            return false;
        }

        // Credencial de estudiante
        if ( isStudent && !fileCredencial.file ) {
            Swal.fire("Agregar documento.", `Selecciona un archivo como credencial de estudiante.`, "error");
            return false;
        }

        // Adjuntar archivo
        if (!esOyente) {
            
            if ( fileResumen.file === '' ) {
                Swal.fire("Agregar documento.", `Por favor selecciona un archivo como resumen.`, "error");
                return false;
            }
            // Indico archivo pero no es un PDF
            const fullName = fileResumen.file.name;
            const fileExt = fullName.substring( fullName.lastIndexOf('.') + 1 ).toUpperCase();
            if ( fileResumen.file !== '' && fileExt !== 'PDF' ) {
                Swal.fire("Documento incorrecto.", `La credencial debe ser un archivo PDF.`, "error");
                return false;
            }
        }

        return true;
    }


    // Procesamiento de la info
    const isDataProcessed = async() => {
        console.log("isDataProcessed...");

        // Grabar en la base de datos
        const resultPost = await postIn({ table:event.tabla, values:formValues });
        console.log(resultPost);

        // Subir credencial de estudiante
        let urlCredencial = '';
        if (isStudent) {
            // const file = fileCredencial;
            // const fileName = `${refBancaria}_credencial.pdf`
            const resultUpload = await uploadFile({ 
                file: fileCredencial, 
                fileName: `${refBancaria}_credencial.pdf` 
            });
            console.log(resultUpload);
            if (resultUpload.exito === 0) {
                return false;
            }
            urlCredencial = `https://eventos.cibnor.mx/registro/apiServiciosSIARF${resultUpload.data}`;
        }
        
        // Si no es oyente, subir archivos
        let urlResumen = '';
        let urlExtenso = '';
        if (!esOyente) {
            // - Subir resumen obligatorio
            const resultUploadResumen = await uploadFile({ 
                file: fileResumen, 
                fileName: `${refBancaria}_resumen.pdf` 
            });
            console.log("resultUploadResumen", resultUploadResumen);
            if (resultUploadResumen.exito === 0) {
                return false;
            }
            urlResumen = `https://eventos.cibnor.mx/registro/apiServiciosSIARF${resultUploadResumen.data}`;

            // - Subir extenso (opcional)
            if ( fileExtenso.file !== "" ) {

                // Subir resumen obligatorio
                const resultUploadExtenso = await uploadFile({ 
                    file: fileResumen, 
                    fileName: `${refBancaria}_extenso.pdf` 
                });
                console.log("resultUploadExtenso", resultUploadExtenso);
                if (resultUploadExtenso.exito === 0) {
                    return false;
                }
                urlExtenso = `https://eventos.cibnor.mx/registro/apiServiciosSIARF${resultUploadExtenso.data}`;
            }                 
        }

        // Enviar correo
        // - Crear cuerpo del correo
        const title = event.tituloEvento;
        const urlLogo = event.urlLogo;
        const urlConfirma = `${process.env.REACT_APP_HOMEPAGE}/confirmar-registro/${formValues.refBancaria}`;
        const urlVisualiza = `${process.env.REACT_APP_HOMEPAGE}/visualizar-registro/${formValues.refBancaria}`;

        // - Data adicional, para enlaces a los documentos subidos
        const aditionalData = 
            "<h3>información adicional:</h3>" +
            "<ul>" +
            // (( !esOyente ) ? `<h4><a href=${ urlResumen }>Resumen</a></h4>`: '') +
            (( fileCredencial.file !== "" ) ? `<h4><a href=${ urlCredencial }>Credencial de estudiante</a></h4>`: '') +
            (( fileResumen.file !== "" ) ? `<h4><a href=${ urlResumen }>Resumen</a></h4>`: '') +
            (( fileExtenso.file !== "" ) ? `<h4><a href=${ urlExtenso }>Trabajo en extenso</a></h4>`: '') +
            `<h4>Puede consultar los detalles de su registro en <a href=${urlVisualiza}>este enlace</a> o escaneando el codigo QR</h4>` +
            "</ul>";

        const eventValues = { title, urlConfirma, urlVisualiza, urlLogo, aditionalData };

        const msgbody = renderToString( setEmailBodyConfirm({ formValues, eventValues, src }) );

        // - Se genera el cc
        let toccAddresses = (process.env.REACT_APP_TOBCC_FACTURACION !== '') ? event.correoEvento : '';

        // - Se envia el correo
        const emailResult = await sendEmail({
            "toemail": partCorreo,
            "subject": `[${event.tituloEvento}] CIBNOR`,
            "message": msgbody,
            "replyto": event.correoEvento,
            "tocc": toccAddresses,
        });
        console.log(emailResult);

        return true;
    }


    // Del sweetalert, cuando el usuario decide "continuar"
    const continueConfirmed = async() => {
        console.log("continueConfirmed...");

        // Mostrar waiting dialog 
        setSendingForm(true);

        // Se procesa la info
        const resultDataProcessed = await isDataProcessed(); 

        // Ocultar waiting dialog
        setSendingForm(false);

        // Dependiendo el resultado se notifica al usuario...
        if (resultDataProcessed) {
            Swal.fire({
                allowEscapeKey: false,
                // allowOutsideClick: false,
                confirmButtonText: 'Ver más eventos',
                icon: 'success',
                text: 'Consulte su correo electrónico para más información.',
                title: "Sus datos han sido recibidos exitosamente",
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.replace('https://www.cibnor.gob.mx/catalogo-de-eventos');
                }
            }); 
        } else {
            // Notificar del error al usuario y enviar email a developer
            Swal.fire({
                allowEscapeKey: false,
                allowOutsideClick: false,
                title: "Sucedío un error en el servidor.",
                text: 'Disculpe el inconveniente, por favor reintente más tarde.',
                icon: 'error',
                showConfirmButton: false,
                footer: 'El area correspondiente ya ha sido notificada.'
            }); 
            sendEmail({
                "toemail": "jcollins@cibnor.mx",
                "subject": `Error [${event.tituloEvento}]`,
                "message": `resultDataProcessed: ${resultDataProcessed} | formValues: ${formValues} | src: ${src}`,
            });
        }
    }

    // Al enviar formulario
    const handleSubmit = async (event) => {
        event.preventDefault();
        console.log("submit...");

        // Validar datos
        if ( !isFormValid() ) {
            return false;
        }

        // Mostrar confirm dialog/waiting dialog
        Swal.fire({
            title: '¿Desea continuar?',
            text: "Por favor, confirme la información ingresada.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Regresar',
        }).then((result) => {
            if (result.isConfirmed) {
                // procesar data
                continueConfirmed();
            }
        })

        console.log(partApellidoPaterno,
            partApellidoMaterno,
            partNombres,
            partCorreo,
            partCorreoConfirma,
            partGenero,
            partInstitucion,
            partOcupacion,
    
            tipoRegistro,
            comentarios,
    
            extranjero,
            factPais,
            requiereFactura,
            factNombre,
            factRfc,
            factCP,
            factUsoCFDI,
            factRegimenFiscal,
            refBancaria,
            claveProyRec,
            fechaRegistro,
            compPago,
            fechaPago,);
    }


    useEffect(() => {

        const setInitialValues = async() => {

            setIsLoading(true);

            // Indicamos el proyecto asignado a este evento
            const PROY_RECURSOS = '20461';

            // +++ Recuperamos el evento y asignamos valores
            const resultProyDataLoaded = await getOneInByClave({ table:'EventosConRegistro', clave:PROY_RECURSOS });
            console.log(resultProyDataLoaded);

            // No existe el proyecto y muestra mensaje
            if (resultProyDataLoaded.exito === 0) {
                Swal.fire({
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    title: "Evento no disponible",
                    text: "Comuniquese a inscripciones@cibnor.mx para mayor información.",
                    confirmButtonText: 'Catálogo de eventos',
                    icon: 'warning',
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.replace('https://www.cibnor.gob.mx/catalogo-de-eventos');
                    }
                }); 
            }
            const ProyData = resultProyDataLoaded.data[0];
            // Asignamos los valores al state
            setEvent({ ...ProyData });

            // Titulo de la pagina / pestaña
            document.title = `[${ProyData.tituloEvento}] CIBNOR`;

            // +++ Asignamos valores
            // Se genera la referencia incluyendo el proyecto
            const resultGenerateRef = generateRef({ prefix:PROY_RECURSOS });
            // Obtenemos el dato para el campo 'fechaRegistro'
            const dateNow = moment().format('YYYY-MM-DDTHH:mm:ss');

            // Asignamos los valores al state
            setFormValues({
                ...formValues,
                claveProyRec: PROY_RECURSOS,
                fechaRegistro: dateNow,
                refBancaria: resultGenerateRef,
            })

            // +++ Generamos el QR
            const qrString = `${process.env.REACT_APP_HOMEPAGE}/visualizar-registro/${resultGenerateRef}`;
            QRCode.toDataURL( qrString )
            .then( (data) => {
                setSrc( { qrdata:data } );
            })

        }; 

        setInitialValues();

        setIsLoading(false);
    }, [  ]);

    return (
        <ThemeProvider theme={createTheme()}>
            <Container component="main" maxWidth="sm">
                <CssBaseline />
                <Box
                    sx={{
                        mt: 2,
                        mb: 6,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <ApplicationBar 
                        title={ event.tituloEvento }
                        subtitle="Registro inicial de participantes" 
                        logo={ event.urlLogo }
                    />
                </Box>
                {/* Inicio del formulario */}
                <Box
                    component="form"
                    noValidate
                    onSubmit={handleSubmit}
                    sx={{ mt: 2 }}
                    autoComplete="off"
                    maxWidth="sm"
                >
                    {/* Participante */}
                    <Paper elevation={2}>
                        <GroupUserData parentCallback={handleInputChange}
                            title='Sección 1. Datos del participante' 
                            userEmail='partCorreo' 
                            userEmailLabel='Correo electrónico' 
                            userFatherName='partApellidoPaterno' 
                            userFatherNameLabel='Apellido Paterno' 
                            userMotherName='partApellidoMaterno' 
                            userMotherNameLabel='Apellido Materno' 
                            userName='partNombres' 
                            userNameLabel='Nombre(s)' 
                            variant='standard' 
                        />
                        <Grid container spacing={2} sx={{ pb: 2, pl: 2, pr: 2 }}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="partCorreoConfirma"
                                    label="Confirmar correo electrónico"
                                    name="partCorreoConfirma"
                                    required
                                    size="small"
                                    // value={partCorreoConfirma}
                                    onChange={handleInputChange}
                                    onPaste={ (e) => e.preventDefault() }
                                    variant='standard' 
                                />
                            </Grid>
                            {/* Genero */}
                            <SelectCustomWithOther 
                                parentCallback={handleInputChange}
                                name={"partGenero"}
                                label={"Género"}
                                options={[
                                    {value:'Hombre', label:'Hombre'},
                                    {value:'Mujer', label:'Mujer'},
                                ]}
                                required
                                paddingH={2}
                                variant='standard' 
                            />
                            {/* Institución laboral o académica */}
                            <Grid item xs={12} >
                                <TextField
                                    fullWidth
                                    id="partInstitucion"
                                    label={`Nombre de la institución`}
                                    name="partInstitucion"
                                    required
                                    size="small"
                                    value={partInstitucion}
                                    onChange={handleInputChange}
                                    variant='standard'
                                />
                            </Grid>
                            <SelectCustomWithOther 
                                parentCallback={handleOcupacionChange}
                                name={"partOcupacion"}
                                label={"Puesto u ocupación"}
                                options={[
                                    {value:'Estudiante de licenciatura', label:'Estudiante de licenciatura'},
                                    {value:'Estudiante de maestría', label:'Estudiante de maestría'},
                                    {value:'Estudiante de doctorado', label:'Estudiante de doctorado'},
                                    {value:'Técnico académico', label:'Técnico académico'},
                                    {value:'Profesor investigador', label:'Profesor investigador'},
                                    {value:'Postdoctorante', label:'Postdoctorante'},
                                ]}
                                required
                                paddingH={2}
                                variant='standard'
                            />
                            {/* Credencial de estudiante */}
                            <Grid item xs={12} sx={{ display:(isStudent) ? 'flex' : 'none' }} >
                                <TextField
                                    type={"file"}
                                    fullWidth
                                    name="fileCredencial"
                                    variant="standard"
                                    onChange={e => setFileState(e)}
                                    helperText="Agregar credencial en formato PDF *"
                                />
                            </Grid>
                            {/* Modalidad de participación */}
                            {/* <Grid item xs={12}>
                                <Typography variant="subtitle1" sx={{ pt: 3, fontWeight: 500 }} >
                                    Sección 2. Modalidad de participación
                                </Typography>
                            </Grid> */}
                            {/* Tipo de registro */}
                            {/* <Grid item xs={12}>
                                <SelectCustom 
                                    parentCallback={handleTipoRegistroChange}
                                    name={"tipoRegistro"}
                                    label={"Tipo de registro"}
                                    options={[
                                        {value:'Presentación oral', label:'Presentación oral'},
                                        {value:'Poster en modalidad electrónica', label:'Poster en modalidad electrónica'},
                                        {value:'Poster en modalidad impresa', label:'Poster en modalidad impresa'},
                                        {value:'Videos cortos', label:'Videos cortos'},
                                        {value:'Oyente', label:'Oyente'},
                                    ]}
                                    required
                                    variant='standard' 
                                />
                            </Grid> */}

                            {/* Ocultar/mostrar un bloque, requiere: Slide, Grid-item, Grid-container */}
                            <Slide in={ !esOyente } direction="up" >
                                <Grid item xs={12} sx={{ display:(!esOyente ? 'flex' : 'none') }} >
                                    <Grid container spacing={2} >

                                        {/* fileResumen */}
                                        <Grid item xs={12} >
                                            <TextField
                                                type={"file"}
                                                fullWidth
                                                name="fileResumen"
                                                variant="standard"
                                                onChange={e => setFileState(e)}
                                                helperText="Adjuntar resumen en formato PDF *"
                                                sx={{ pt: 3, fontWeight: 500 }} 
                                            />
                                        </Grid>
                                        {/* fileExtenso */}
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle1" sx={{ pt: 2, textAlign:'justify', fontWeight: 100 }} >
                                            Opcional: adjuntar trabajo en extenso para potencial publicación en libro o revista de reconocimiento CONACYT conteniendo las siguientes secciones: Título y autores, Resumen, Introducción, Métodos y Materiales, Resultados, Discusión, Conclusiones, Recomendaciones para esfuerzos futuros de investigación y Referencias.
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} >
                                            <TextField
                                                type={"file"}
                                                fullWidth
                                                name="fileExtenso"
                                                variant="standard"
                                                onChange={e => setFileState(e)}
                                                helperText="Adjuntar archivo en extenso en formato PDF"
                                            />
                                        </Grid>

                                    </Grid>
                                </Grid>
                            </Slide>

                            {/* Comentarios adicionales */}
                            <Grid item xs={12}>
                                <TextareaCustom
                                    parentCallback={handleInputChange}
                                    name="comentarios"
                                    label="Comentarios adicionales"
                                    variant="filled"
                                />
                            </Grid>

                        </Grid>
                    </Paper>

                    {/* Boton submit */}
                    <ButtonSubmit label={`Enviar`} />
                    {/* Footer */}
                    <Footer />

                </Box>
            </Container>
            {/* Dialogo de cargando info */}
            <WaitDialog show={isLoading} />
            
            {/* Dialogo 'enviando la informacion' */}
            <SendingDialog show={sendingForm} />
            
        </ThemeProvider>
    );
};
